import { CONTAINS, IS_EMPTY, IS_NOT_EMPTY, IS_NOT_ONE_OF, IS_ONE_OF, NOT_CONTAINS, STARTS_WITH, TEXT_IS, TEXT_IS_NOT } from '../filter-conditions.js';
export const dropdownFilterConditions = [
    IS_ONE_OF,
    IS_NOT_ONE_OF,
    TEXT_IS,
    TEXT_IS_NOT,
    IS_EMPTY,
    IS_NOT_EMPTY,
    CONTAINS,
    NOT_CONTAINS,
    STARTS_WITH,
];
//# sourceMappingURL=filters.js.map